/** Canonical URLs for the five dashboard categories. */
export const DASHBOARD_CATEGORY_PATHS = {
  overview: '/general-overview',
  insights: '/insights',
  suppliers: '/suppliers',
  modules: '/modules',
  tools: '/tools',
} as const

export type DashboardCategoryKey = keyof typeof DASHBOARD_CATEGORY_PATHS

/** Canonical category URL; unknown keys fall back to Insights. */
export function dashboardCategoryPath(key: string): string {
  return DASHBOARD_CATEGORY_PATHS[key as DashboardCategoryKey] ?? DASHBOARD_CATEGORY_PATHS.insights
}

/** Which category a URL belongs to, or null for a child/settings page. */
export function dashboardCategoryForPath(path: string): DashboardCategoryKey | null {
  const match = Object.entries(DASHBOARD_CATEGORY_PATHS).find(([, value]) => value === path)
  return match ? (match[0] as DashboardCategoryKey) : null
}
